import { render, staticRenderFns } from "./LaboratoryReferenceRangeInputForm.vue?vue&type=template&id=5353278e&scoped=true&"
import script from "./LaboratoryReferenceRangeInputForm.vue?vue&type=script&lang=js&"
export * from "./LaboratoryReferenceRangeInputForm.vue?vue&type=script&lang=js&"
import style0 from "./LaboratoryReferenceRangeInputForm.vue?vue&type=style&index=0&id=5353278e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5353278e",
  null
  
)

export default component.exports